import { Modal, Button, Alert } from 'react-bootstrap';
import { FaCoins, FaExclamationCircle, FaCheck } from 'react-icons/fa';

/**
 * MODAL DE CONFIRMATION NON CASH - Modal simple de confirmation pour la distribution Non Cash
 * @param {Object} props
 * @param {boolean} props.show - Si le modal est visible
 * @param {Function} props.onHide - Fonction pour fermer le modal
 * @param {Function} props.onConfirm - Fonction appelée lors de la confirmation
 * @param {Object} props.event - L'événement à distribuer
 * @param {boolean} props.loading - État de chargement
 */
const NonCashConfirmationModal = ({ show, onHide, onConfirm, event, loading }) => {
  if (!event) return null;

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered
      size="md"
    >
      <Modal.Header closeButton className="border-bottom-0">
        <div className="d-flex align-items-center">
          <div className="bg-primary bg-opacity-10 p-2 rounded-circle me-3">
            <FaCoins className="text-white" size={24} />
          </div>
          <div>
            <Modal.Title className="h5 mb-1">
              Confirmer la Distribution
            </Modal.Title>
            <div className="text-muted small">
              Distribution de titres Non Cash
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body className="py-4">
        {/* Alerte d'information */}
        <Alert variant="info" className="border-0 bg-light-info mb-4">
          <div className="d-flex align-items-start">
            <FaExclamationCircle className="text-info mt-1 me-3 flex-shrink-0" />
            <div>
              <strong>Type: Non Cash</strong>
              <p className="mb-0 small">
                Vous êtes sur le point de distribuer {event.nombreTitre || 'N/A'} titres.
                Cette action ne nécessite pas de paramètres supplémentaires.
              </p>
            </div>
          </div>
        </Alert>

        {/* Détails de l'opération */}
        <div className="bg-light rounded p-3 mb-3">
          <h6 className="text-dark mb-2">Détails de l'opération</h6>
          <div className="small">
            <div className="d-flex justify-content-between mb-1">
              <span className="text-muted">Type:</span>
              <span className="fw-semibold">{event.type}</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span className="text-muted">Nombre de titres:</span>
              <span className="fw-semibold">{event.nombreTitre || 'N/A'}</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span className="text-muted">Titre:</span>
              <span className="fw-semibold">{event.securityName}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span className="text-muted">ISIN:</span>
              <span className="fw-semibold">{event.securityIsin}</span>
            </div>
          </div>
        </div>

        {/* Message de confirmation */}
        <div className="text-center text-muted small">
          <FaExclamationCircle className="text-warning me-1" />
          Cette action est irréversible. Confirmez-vous la distribution ?
        </div>
      </Modal.Body>

      <Modal.Footer className="border-top-0">
        <Button 
          variant="outline-secondary" 
          onClick={onHide}
          disabled={loading}
        >
          Annuler
        </Button>
        <Button 
          variant="primary" 
          onClick={onConfirm}
          disabled={loading}
          className="d-flex align-items-center gap-2"
        >
          {loading ? (
            <>
              <div className="spinner-border spinner-border-sm" role="status" />
              Traitement...
            </>
          ) : (
            <>
              <FaCheck />
              Confirmer la Distribution
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NonCashConfirmationModal;